export default __webpack_public_path__ + "media/img_01/300@2x-167429fc.jpg";